module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js!./health-im.cfwidget.tsx"));
	}, "health");
}